// extracted by mini-css-extract-plugin
module.exports = {"component":"CartSummary_component__xjKKy","toPay":"CartSummary_toPay__0KT4j"};